// extracted by mini-css-extract-plugin
export default {"pdf":"Pdf_pdf__zJzm8","loading":"Pdf_loading__qum9E","loadingText":"Pdf_loadingText__kUg2Q","pages":"Pdf_pages__CsQLw","numPages":"Pdf_numPages__tJtWc"};